import * as React from 'react';
import * as CSSTransition from 'react-transition-group/CSSTransition';
import {css, keyframes} from 'emotion';

const messageFadeIn = keyframes`
  0% {
    opacity: 0;
    max-height: 0;
    padding: 0;
  }
  100% {
    opacity: 1;
    max-height: 150px;
    padding: 8px;
  }
`;

const messageFadeOut = keyframes`
  0% {
    opacity: 1;
    max-height: 150px;
    padding: 8px;
  }
  100% {
    opacity: 0;
    max-height: 0;
    padding: 0;
  }
`;

const styles = {
  enter: css`
    opacity: 0;
    animation-duration: 0.24s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    animation-play-state: paused;
  `,

  exit: css`
    animation-duration: 0.2s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    animation-play-state: paused;
  `,

  enterActive: css`
    animation-name: ${messageFadeIn};
    animation-play-state: running;
  `,

  exitActive: css`
    animation-name: ${messageFadeOut};
    animation-play-state: running;
  `
};

export default class MessageFade extends React.Component {
  public render() {
    return <CSSTransition {...this.props} classNames={styles} timeout={{enter: 240, exit: 200}} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Messages/private/MessageFade.tsx